import { logout, useAuthStore } from "@/features/auth/useAuth";
import AddHomeIcon from "@mui/icons-material/AddHome";
import HomeIcon from "@mui/icons-material/Home";
import LogoutIcon from "@mui/icons-material/Logout";
import PeopleIcon from "@mui/icons-material/People";
import WeekendIcon from "@mui/icons-material/Weekend";
import WorkIcon from "@mui/icons-material/Work";
import {
  Box,
  Divider,
  Drawer,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Typography,
} from "@mui/material";
import { useNavigate } from "react-router-dom";

interface Props {
  open: boolean;
  onClose: () => void;
}

export function AppDrawer({ open, onClose }: Props) {
  const nav = useNavigate();
  const { user } = useAuthStore();
  const isAdmin = user?.role === "admin" || (user != null && user.owner === null);

  function go(to: string) {
    void nav(to);
    onClose();
  }

  async function handleLogout() {
    await logout();
    onClose();
    void nav("/login", { replace: true });
  }

  return (
    <Drawer anchor="left" open={open} onClose={onClose}>
      <Box
        sx={{
          width: 260,
          bgcolor: "primary.main",
          color: "primary.contrastText",
          px: 3,
          py: 2,
        }}
      >
        <Typography variant="h6">Menu</Typography>
      </Box>
      <List sx={{ width: 260 }}>
        <ListItemButton onClick={() => go("/")}>
          <ListItemIcon>
            <HomeIcon color="primary" />
          </ListItemIcon>
          <ListItemText primary="Home" />
        </ListItemButton>
      </List>
      <Divider />
      <Typography variant="caption" sx={{ px: 3, pt: 1, color: "text.secondary" }}>
        Administration
      </Typography>
      <List>
        {isAdmin && (
          <ListItemButton onClick={() => go("/administration/users")}>
            <ListItemIcon>
              <PeopleIcon />
            </ListItemIcon>
            <ListItemText primary="Users" />
          </ListItemButton>
        )}
        <ListItemButton onClick={() => go("/administration/stagings")}>
          <ListItemIcon>
            <AddHomeIcon />
          </ListItemIcon>
          <ListItemText primary="Stagings" />
        </ListItemButton>
        <ListItemButton onClick={() => go("/administration/inventory")}>
          <ListItemIcon>
            <WeekendIcon />
          </ListItemIcon>
          <ListItemText primary="Inventory" />
        </ListItemButton>
        <ListItemButton onClick={() => go("/administration/templates")}>
          <ListItemIcon>
            <WorkIcon />
          </ListItemIcon>
          <ListItemText primary="Templates" />
        </ListItemButton>
      </List>
      <Divider />
      <List>
        <ListItemButton onClick={() => void handleLogout()}>
          <ListItemIcon>
            <LogoutIcon />
          </ListItemIcon>
          <ListItemText primary="Logout" />
        </ListItemButton>
      </List>
    </Drawer>
  );
}
